import React from 'react'
import { useTranslation } from 'react-i18next'
import { getFilteredResultsFromEnergyBus } from '../../calculators/calculator-result-utility'
import {
  EnergyBusCalculator,
  heatInKeys,
  heatOutKeys,
} from '../../calculators/EnergyBusCalculator'
import { EnergyBusResultKey } from '../../provider/result-categories'
import { SystemContainerSidebarTable } from '../system-container/sidebar/SystemContainerSidebarTable'
import { VersionComparisonSelect } from '../version-comparison/VersionComparisonSelect'

type Props = {
  energyBus: EnergyBusCalculator
  comparisonEnergyBus?: EnergyBusCalculator | null
}

export function EnergyBusSidebarContent({
  energyBus,
  comparisonEnergyBus,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  const keysToRowData = (key: EnergyBusResultKey) => ({
    title: t(`energyBus.sidebar.${key}`),
    result: getFilteredResultsFromEnergyBus(energyBus, key),
    comparisonResult: comparisonEnergyBus
      ? getFilteredResultsFromEnergyBus(comparisonEnergyBus, key)
      : undefined,
  })

  const tableData = [
    {
      header: t('energyBus.sidebar.heatIn'),
      rowData: heatInKeys.map(keysToRowData),
    },
    {
      header: t('energyBus.sidebar.heatOut'),
      rowData: heatOutKeys.map(keysToRowData),
    },
  ]

  return (
    <>
      {tableData.map((table) => (
        <SystemContainerSidebarTable
          key={table.header}
          header={table.header}
          rowData={table.rowData}
          isComparisonVisible={comparisonEnergyBus !== undefined}
        />
      ))}

      <VersionComparisonSelect />
    </>
  )
}
